export function ucFirst(val) {
    return val.charAt(0).toUpperCase() + val.slice(1);
}
